"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildPrefixedComponentBundleId = buildPrefixedComponentBundleId;
exports.buildComponentAndLocale = buildComponentAndLocale;
exports.extractComponentAndLocale = extractComponentAndLocale;
const enums_1 = require("@aurora/shared-types/overrides/enums");
const delimiter = '-';
function buildComponentAndLocale(componentId, locale) {
    return `${componentId}${delimiter}${locale}`;
}
function buildBundleId(componentId, locale, lastModified) {
    return `${buildComponentAndLocale(componentId, locale)}${delimiter}${lastModified !== null && lastModified !== void 0 ? lastModified : 0}`;
}
function extractComponentAndLocale(value) {
    // Split string at hyphens
    const parts = value.split('-');
    // Get component ID (all parts except the last two for region case, or last one for single locale)
    const isRegionCase = parts.length > 2 && parts.at(-1).length === 2 && parts.at(-2).length === 2;
    let componentId, locale;
    if (isRegionCase) {
        componentId = parts.slice(0, -2).join('-');
        locale = `${parts.at(-2)}-${parts.at(-1)}`.toLowerCase();
    }
    else {
        componentId = parts.slice(0, -1).join('-');
        locale = parts.at(-1).toLowerCase();
    }
    return { componentId, locale };
}
/**
 * Builds an identifier to be used as an Apollo cache key for Component assets
 * @param componentId component identifier
 * @param locale component texts locale
 * @param lastModified last modified timestamp
 */
function buildPrefixedComponentBundleId(componentId, locale, lastModified) {
    return `${enums_1.CachedAssetType.COMPONENT}:${buildBundleId(componentId, locale, lastModified)}`;
}
//# sourceMappingURL=ApolloComponentCacheHelper.js.map